import React, { useEffect, useState } from "react";
import Image from "../../assets/imgs/history/serrinha.jpg";

const History = () => {
  const [historyData, setHistorys] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const historyData = [
        { id: 1, prefeito: "MANOEL DO CARMO SANTOS", mandato: "1970-1972" },
        { id: 2, prefeito: "JOSÉ TEIXEIRA DE SOUZA", mandato: "1973-1976" },
        { id: 3, prefeito: "MANOEL DO CARMO DOS SANTOS", mandato: "1977-1982" },
        { id: 4, prefeito: "JOÃO VICENTE DA CRUZ", mandato: "1983-1988" },
        {
          id: 5,
          prefeito: "MARLUCE RODRIGUES DOS SANTOS",
          mandato: "1989-1992",
        },
        { id: 6, prefeito: "JOSÉ GENILSON O. DE SOUZA", mandato: "1993-1996" },
        {
          id: 7,
          prefeito: "JOSÉ TEIXEIRA DE SOUZA JÚNIOR",
          mandato: "1997-2000",
        },
        {
          id: 8,
          prefeito: "JOSÉ TEIXEIRA DE SOUZA JÚNIOR",
          mandato: "2001-2004",
        },
        { id: 9, prefeito: "MANOEL DO CARMO DOS SANTOS", mandato: "2005-2008" },
        { id: 10, prefeito: "FABIANO DE SOUZA", mandato: "2009-2012" },
        { id: 11, prefeito: "FABIANO DE SOUZA", mandato: "2013-2016" },
        { id: 12, prefeito: "JOSÉ ANTÔNIO DE MEDEIROS CLEMENTE", mandato: "2017-2020" },
        { id: 13, prefeito: "JOSÉ ANTÔNIO DE MEDEIROS CLEMENTE", mandato: "2021-2024" },
        {
          id: 14,
          prefeito: "KAUANNY TERTO",
          mandato: "Atualmente",
        },
      ];

      setHistorys(historyData);
    };

    fetchData();
  }, []);

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <p className="text-gray-800 mb-4">
          Serrinha, município no estado do Rio Grande do Norte, localizado na
          microregião do Agreste Potiguar. De acordo com o censo realizado pelo
          IBGE (Instituto Brasileiro de Geografia e Estatística) no ano 2000,
          sua população é de 7.253 habitantes. Área territorial de 191 km², o
          que corresponde a uma densidade populacional de 38 hab/km².
        </p>

        <p className="text-gray-800 mb-4">
          Esta comunidade do agreste potiguar está localizada ao pé da serra que
          lhe deu o nome. Serrinha, denominada por uma grande pedra, é a
          principal beleza natural deste município. Antigamente chamada de
          Serrinha do Olho D´Água. Ela surgiu da expansão da pecuária
          pernambucana na segunda metade do século XIX, quando aí fixou
          residência o capitão Cecílio Correia de Andrade.
        </p>

        <img
          src={Image}
          alt="Cidade de Serrinha"
          className="w-full h-auto rounded-2xl mb-6"
        />

        <p className="text-gray-800 mb-4">
          Outros povoadores fizeram a mesma trajetória, tais como Luís Antônio
          Aguiar, Vicente Barros e Sebastião Sátirio da Costa, vindos também de
          Pernambuco e da Paraíba. O município tem como marco histórico os
          cacimbões construídos no século XIX, ainda na época do império, pelo
          então Capitão Cecílio Correia de Andrade, àquela época, senhor das
          terras onde ficavam escravos. Estes cacimbões foram então construídos
          de tijolos, barro e cimento com, aproximadamente 12 metros de
          profundidade.
        </p>

        <p className="text-gray-800 mb-4">
          No dia 2 de outubro de 1963, através da Lei n°2.942, o povoado foi
          desmembrado do território de Santo Antônio, tornando um novo município
          com a denominação Serrinha.
        </p>

        <p className="text-gray-800 mb-4">
          Após a instalação do município, o seu primeiro governante foi o Sr.
          João Evangelista de Salles, que foi nomeado o primeiro intendente,
          tendo governado até o final de 1964. O primeiro prefeito eleito foi o
          Sr. José Teixeira de Souza que iniciou uma nova era de progresso. Sua
          gestão no período de 1965 até 1969 foi marcada por avanços.
        </p>

        <h2 className="text-3xl text-center font-black text-blue-900 my-8">
          Prefeitos de Serrinha
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4">
          {historyData.map((item) => (
            <div
              key={item.id}
              className="bg-gray-100 shadow-md rounded-2xl p-4 text-center"
            >
              <h3 className="text-2xl font-black text-blue-800">
                {item.mandato}
              </h3>
              <p className="text-gray-600 font-bold mt-2">{item.prefeito}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default History;
